import { render } from "./Galerry.vue?vue&type=template&id=5f409980"
import script from "./Galerry.vue?vue&type=script&lang=js"
export * from "./Galerry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__